import types from './attachmentsTypes'

const mutations = {
  [types.SET_ATTACHMENTS]: function(state, payload) {
    state.attachments = payload
  },
}

export default mutations
